import React from 'react';

import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import {NO_ACCESS_TEXT} from 'processes/ProcessConstants';

import {InaccessibleInfoGraphQL} from '../../../graphql-fragments/auth/__generated/InaccessibleInfoGraphQL';

export interface RequestV2DefinitionInfo {
  __typename: 'RequestV2DefinitionNode';
  id: string;
  name: string;
}

interface RequestV2DefinitionListingDisplayProps {
  definitionInfo: RequestV2DefinitionInfo | InaccessibleInfoGraphQL;
}

export default function RequestV2DefinitionListingDisplay(
  props: RequestV2DefinitionListingDisplayProps
): JSX.Element {
  if (isInaccessible(props.definitionInfo)) {
    return <>{NO_ACCESS_TEXT}</>;
  }

  return <>{props.definitionInfo.name}</>;
}
